import React from 'react'
import { LoadState } from '@ally/use-data-domain'
import { Box } from '@ally/metronome-ui'
import { useHostServices } from '../HostServices'
import VehiclesCard from './VehiclesCard'
import ScheduledMaintenance from './ScheduledMaintenance'
import Loader from '../Shared/Loader'

const VehiclesLoader: React.FC = () => {
  const { hostData } = useHostServices()
  const { notifications } = hostData

  const maintenanceNotification = notifications.data?.notifications.find(
    notification =>
      notification.type === 'SCHEDULED_MAINTENANCE' &&
      notification.targetLob.includes('AUTO'),
  )

  switch (notifications.status.loadState) {
    case LoadState.LOADED:
      return maintenanceNotification ? (
        <ScheduledMaintenance
          effectiveFrom={maintenanceNotification.effectiveFrom as string}
          effectiveTill={maintenanceNotification.effectiveTill as string}
        />
      ) : (
        <VehiclesCard />
      )

    case LoadState.FAILED:
      return <VehiclesCard />

    case LoadState.LOADING:
      return (
        <Box mb="lg" data-testid="vehicles-loading">
          <Loader />
        </Box>
      )

    default:
      return <></>
  }
}

export default VehiclesLoader
